import { getSupabaseToken } from '@/services/api';

const API_URL = process.env.VUE_APP_API_URL || 'https://api.query-juriste.com';
const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const IDLE_THRESHOLD_MS = 5 * 60 * 1000;

let intervalId = null;
let lastActivity = Date.now();
let sessionStartedAt = null;

function onActivity() {
  lastActivity = Date.now();
}

function isUserActive() {
  return (Date.now() - lastActivity) < IDLE_THRESHOLD_MS;
}

function isTabVisible() {
  return document.visibilityState === 'visible';
}

async function sendHeartbeat() {
  if (!isTabVisible() || !isUserActive()) return;

  try {
    const token = await getSupabaseToken();
    if (!token) return;

    await fetch(`${API_URL}/copilot/session-heartbeat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        session_started_at: sessionStartedAt,
      }),
      keepalive: true,
    });
  } catch (_) {
    // fire-and-forget
  }
}

export function startHeartbeat() {
  if (intervalId) return;

  sessionStartedAt = new Date().toISOString();
  lastActivity = Date.now();

  window.addEventListener('mousemove', onActivity, { passive: true });
  window.addEventListener('keydown', onActivity, { passive: true });
  window.addEventListener('scroll', onActivity, { passive: true });
  window.addEventListener('click', onActivity, { passive: true });
  window.addEventListener('beforeunload', sendHeartbeat);

  sendHeartbeat();
  intervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
}

export function stopHeartbeat() {
  if (!intervalId) return;

  sendHeartbeat();

  clearInterval(intervalId);
  intervalId = null;
  sessionStartedAt = null;

  window.removeEventListener('mousemove', onActivity);
  window.removeEventListener('keydown', onActivity);
  window.removeEventListener('scroll', onActivity);
  window.removeEventListener('click', onActivity);
  window.removeEventListener('beforeunload', sendHeartbeat);
}
